import { useState } from "react";
import { useRecordContext } from "react-admin";

//Common styles
import {
  BlueBorderContainer,
  BlueTOpBorderContainer,
  ButtonContainer,
  Paragraph,
  SectionTitle,
  ShowLabel,
  ThreeColNRowGrid,
  WorkspacePanel,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

//Common components
import TransactionButton from "../Common/TransactionButton";
import ImagePreviewerDialog from "../Common/ImagePreviewerDialog";

interface DishCategoryTagMetaShowProps {
  onUpdate: (record: any) => void;
}

const FALLBACK_IMAGE =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRODZob7ROpqlx8WXwjueNwTOlC6Qum-yMiyfXiFRXkdhkHgybCpdvM1UpaXCL1ycfO8NI&usqp=CAU";

const DishCategoryTagMetaShow = ({ onUpdate }: DishCategoryTagMetaShowProps) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  const record = useRecordContext();

  if (!record) return null;

  const iconSrc = record?.iconUrl || FALLBACK_IMAGE;

  return (
    <>
      <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
        <WorkspacePanel>
          <BlueBorderContainer>
            <WorkSpaceTitleRow>
              <SectionTitle>Tag Details</SectionTitle>
            </WorkSpaceTitleRow>

            <ButtonContainer>
              <TransactionButton name="Update Tag" onClickHandler={() => onUpdate(record)} />
            </ButtonContainer>
          </BlueBorderContainer>

          <ThreeColNRowGrid>
            <div>
              <ShowLabel>Tag ID</ShowLabel>
              <Paragraph>#{record?.id}</Paragraph>
            </div>

            <div>
              <ShowLabel>Name</ShowLabel>
              <Paragraph>{record?.name || "-"}</Paragraph>
            </div>

            <div>
              <ShowLabel>Slug</ShowLabel>
              <Paragraph>{record?.slug || "-"}</Paragraph>
            </div>

            <div>
              <ShowLabel>Status</ShowLabel>
              <Paragraph>{record?.isActive ? "Active" : "Inactive"}</Paragraph>
            </div>
          </ThreeColNRowGrid>

          <BlueTOpBorderContainer style={{ marginTop: "20px", paddingTop: "10px" }}>
            <div>
              <ShowLabel>Icon URL</ShowLabel>
              <Paragraph>{record?.iconUrl || "-"}</Paragraph>
            </div>
          </BlueTOpBorderContainer>
        </WorkspacePanel>

        <WorkspacePanel style={{ maxWidth: "376px" }}>
          <SectionTitle style={{ marginBottom: 12 }}>Tag Icon</SectionTitle>
          <div
            title={!record.iconUrl ? "Icon Not Available" : "Click to preview"}
            onClick={() => setPreviewOpen(true)}
            style={{
              width: "200px",
              height: "200px",
              backgroundImage: `url(${iconSrc})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "8px",
              cursor: "pointer",
              border: "1px solid rgba(0,0,0,0.08)",
            }}
          />
        </WorkspacePanel>
      </div>

      {previewOpen && (
        <ImagePreviewerDialog
          src={iconSrc}
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </>
  );
};

export default DishCategoryTagMetaShow;
